import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import moment from 'moment';
// i18n
import { withTranslation } from 'react-i18next';
// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  approveJoinRequest,
  declineJoinRequest,
  sendSurveyReminder
} from '../../../modules/reader';
import UnusualActivityBadge from './unusualActivityBadge';
import AppIcon from '../../../components/AppIcon';

export class JoinRequestItem extends Component {
  // lifecycle methods
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // custom methods
  approveJoinRequest = (joinRequestId, contentVersion) => {
    const { idToken, joinRequests } = this.props;
    const joinRequest = joinRequests.find(entry => entry._id === joinRequestId);
    if (joinRequest) {
      this.props.approveJoinRequest(idToken, joinRequest, { contentVersion });
    }
  }

  declineJoinRequest = (event, data) => {
    const { idToken, joinRequests } = this.props;
    var joinRequest = joinRequests.find(joinRequest => {
      return joinRequest._id === data["data-reader-id"];
    })
    if (joinRequest) {
      this.props.declineJoinRequest(idToken, joinRequest);
    }
  }

  sendSurveyReminder = (joinRequest) => {
    const { idToken } = this.props;
    this.props.sendSurveyReminder(idToken, joinRequest);
  }

  // rendering
  render() {
    const { t, reader } = this.props;
    return (
      <div>
        <div>
          <strong>
            {reader.name}
          </strong>
          {
            reader.unusualActivity && (
              <div style={{ margin: '4px 0' }}>
                <UnusualActivityBadge unusualActivity={reader.unusualActivity} />
              </div>
            )
          }
          {
            reader.invitation.requestedAt !== undefined && (
              <div>
                {t('RequestedAt')}: {moment(reader.invitation.requestedAt).fromNow()}<br />
              </div>
            )
          }
          {/* {
            reader.readerSignupSurveyQuestions &&
            reader.readerSignupSurveyQuestions.map((question, index) => {
              return (
                <div key={index} style={{ fontSize: '0.8em' }}>
                  <strong>
                    {question.question}
                  </strong>
                  <br />
                  <em>
                    {question.answer ? question.answer.answer : t('NoAnswer')}
                  </em>
                </div>
              )
            })
          } */}
          {
            // The reminder is only worth offering while questions are still
            // unanswered, but whether one was already sent stays on screen
            // either way — that is the thing an author loses track of when
            // they hold an application open for a week.
            reader.signupSurveyReminderSent && (
              <div style={{ fontSize: '0.8em', color: 'grey' }}>
                <AppIcon name='check' size='small' aria-hidden='true' />
                {t('ReminderSentAt')}
                {' '}
                {moment(reader.signupSurveyReminderSent).fromNow()}
              </div>
            )
          }
          {
            reader.readerSignupSurveyQuestions && reader.readerSignupSurveyQuestions.some(question => question.answer === undefined) &&
            // some questions have not been answered
            <span style={{ fontSize: '0.8em', cursor: 'pointer' }}>
              {
                reader.updating
                  ? <em>{t('Sending...')}</em>
                  : (
                    <button type='button' onClick={() => this.sendSurveyReminder(reader)}
                      style={{border: 0, padding: 0, background: 'transparent',
                        color: 'var(--br-accent)', font: 'inherit', cursor: 'pointer',
                        textDecoration: 'underline'}}>
                      {reader.signupSurveyReminderSent ? t('SendSurveyReminderAgain') : t('SendSurveyReminder')}
                    </button>
                  )
              }
            </span>
          }
        </div>
      </div>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  joinRequests: state.reader.joinRequests
});

const mapDispatchToProps = dispatch => bindActionCreators({
  approveJoinRequest,
  declineJoinRequest,
  sendSurveyReminder,
  changePage: (newPage) => push(newPage),
}, dispatch)

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(JoinRequestItem)));
